// extracted by mini-css-extract-plugin
export default {"goalCard":"projectGoals_goalCard__wFnJL"};